import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
    InvoiceService,

    LrUpdateService
} from "../../../services/index";
import * as fromCommonStore from "../../../store";

@Component({
  selector: "invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./lorryUpdate.html",
})
export class LorryUpdate implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  updateData: any[];

  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  partyList$ = [];
  partyList: Observable<any[]>;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("returnTemplate") returnTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    lr_no: "",
    rec_no: "",
  };

  partyStoreSub;
  itemStoreSub;
  invoiceStoreSub;

  printConfig: any = {
    title: "Sales Invoice",
    columns: [],
    rows: [],
  };
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private invoiceService: InvoiceService,
    public toasterService: ToasterService,
    private lrupdateService: LrUpdateService
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;
           */
    this.invoiceStoreSub = this.store
      .select(fromRootStore.getLoadInvoice)
      .subscribe((isLoad: any) => {
        if (isLoad) {
          this.getUpdateList();
        }
      });

    this.partyStoreSub = this.store
      .select(fromCommonStore.getAllParty)
      .subscribe((res: any) => {
        if (_.isEmpty(res)) {
          return;
        }
        this.partyList$ = res.data;
      });

    /*  this.partyList = this.partyCtrl.valueChanges
              .startWith(null)
              .map(name => name ? this.filterItems(name, 'Party') : this.partyList$.slice());*/
  }

  ngOnInit(): void {
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: true, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        isPrint: false,
      },
      {
        name: "Update No",
        prop: "update_no",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
        align: "right",
        type: "number",
      },
      {
        name: "Updated Date",
        prop: "lr_update_formatted",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        headerClass: "text-center",
        align: "right",
        type: "number",
      },
      {
        name: "Transport",
        prop: "transport",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        headerClass: "text-center",
        align: "right",
        type: "number",
      },
      /*  { name: 'Rec.Wt', prop: 'rec_wt', minWidth: 90, maxWidth: 90, width: 90,headerClass:'text-center', align: 'right', type: 'number' },
            { name: 'Rec.No', prop: 'rec_no', minWidth: 90, maxWidth: 90, width: 90,headerClass:'text-center', align: 'right', type: 'number' },
             { name: 'Rec.Date', prop: 'rec_date_formatted', minWidth: 90, maxWidth: 90, width: 90,headerClass:'text-center', align: 'right', type: 'number' }, */
      {
        name: "Action",
        prop: "action",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
        isPrint: false,
      },
      {
        name: "Return",
        prop: "action",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.returnTemplate,
        isPrint: false,
      },
    ];

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
        this.addEditInvoice("Add", "");
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterinvno").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getUpdateList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    }
    if (nextEl == "applyFilter") {
      this.applyFilter();
    } else {
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getUpdateList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getUpdateList();
  }

  getUpdateList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      lr_no: this.filterData.lr_no,
      rec_no: this.filterData.rec_no || "",
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.lrupdateService
      .getLRUpdate(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.updateData = res.data;

        that.printConfig = {
          title: "Purchase Invoice",
          sumtitle: "TOTAL",
          columns: that.columns,
          rows: res.data,
        };
      });
  }

  clearFilter(): void {
    this.filterData.lr_no = "";
    this.filterData.rec_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getUpdateList();
  }

  /*  filterItems(name: string, comboType: string) {
          let list: any[];
          if (comboType == "Party") {
              list = this.partyList$
          }
          name = _.escapeRegExp(name);
          return list.filter(item => (new RegExp(name, 'gi').test(item.name)));
      }*/

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Party") {
      list = this.partyList$;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  addEditInvoice(mode: string, row: any): void {
        this.filterExpand = true;

    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.filterExpand = true;
      this.getUpdateList();
    });
    row.tabevent = listUpdateEvent;

    if (mode == "Edit") {
      let tabObj = {
        action: "NewTab",
        params: {
          tabParent: "CLOTH",
          tabName: "EDIT LR UPDATE",
          id: "AddEditLorryUpdate",
          name: "AddEditLorryUpdate",
          mode: mode,
          data: row,
        },
      };
      this.tabUpdateEvent.emit(tabObj);
    } else if(mode == 'Return') {
      let tabObj = {
        action: "NewTab",
        params: {
          tabParent: "CLOTH",
          tabName: "RETURN LR/INVOICE",
          id: "AddEditLorryUpdate",
          name: "AddEditLorryUpdate",
          mode: mode,
          data: row,
        },
      };
      this.tabUpdateEvent.emit(tabObj);
    }else {
      let tabObj = {
        action: "NewTab",
        params: {
          tabParent: "CLOTH",
          tabName: "ADD LR UPDATE",
          id: "AddEditLorryUpdate",
          name: "AddEditLorryUpdate",
          mode: mode,
          data: row,
        },
      };
      this.tabUpdateEvent.emit(tabObj);
    }
  }

  deleteInvoice(row: any): void {
    let that = this;
    row.tabevent = undefined;
    swal({
      title: "Are you sure to delete this Details?",
      text: "You will not be able to recover this Details",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.invoiceService
          .deleteLorryDet(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getUpdateList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }

  @ViewChild("printPage") printPage;
  onPrintInvoice(row) {
    this.printConfig = {
      type: "invoice",
      title: "Sales Invoice",
      rows: row,
    };

    setTimeout(() => {
      this.printPage.printPreview();
    }, 100);
  }

  ngOnDestroy() {
    this.partyStoreSub.unsubscribe();
    this.invoiceStoreSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/lorryUpdate/lorryUpdate.ts